<template>
  <el-table
    :data="tableData"
     ref="table"
     style="width: 100%"
     @sort-change="sortChange"
     @cell-click="cellClickFtn"
     :cell-class-name="tableCellClassName"
     :span-method="objectSpanMethod"
     :max-height="maxHeight"
     :header-cell-style="{background:'#E6E5E5',color:'#000'}"
     :border="true"
     >
     <el-table-column v-for="(item,index) in headColumn" :key="index"
      :prop="item.prop"
      :label="item.label"
      :align="item.align"
      :sortable="item.sortable"
      show-overflow-tooltip
      :width="item.width"
     >
        <template  slot-scope="scope" >
            <span :style="item.style" class="myNote">{{scope.row[item.prop]}}</span>
        </template>

        <template v-if="item.child">
            <el-table-column v-for="(child,index) in item.child" :key="index"
              :prop="child.prop"
              :label="child.label"
              :align="child.align"
              :sortable="child.sortable"
              show-overflow-tooltip
            >
              <template  slot-scope="scope" >
                      <span :style="child.style" class="myNote">{{scope.row[child.prop]}}</span>
              </template>
            </el-table-column>
        </template>
        <!-- 如果没有子层 但是有自定义样式 -->
        <!-- {{item.style}} -->
    </el-table-column>

  </el-table>
</template>
<script>
// import echarts from 'echarts'

export default {
  name: 'FtaComplexTable',
  props: {
    headColumn: {
      type: Array /* 表头 */
    },
    tableData: {
      type: Array /* 数据 */
    },
    sortMethod:{  /* 是否有排序功能   默认没有是0*/
      type:Number,
      default:0
    },
    spanMethod:{  /* 是否有合并单元格功能   默认没有是0*/
      type:Number,
      default:0
    },
    clickFtn:{  /* 是否有点击单元格功能   默认没有是0*/
      type:Number,
      default:0
    },
    maxHeight:{  /* 最大高度*/
      type:Number,
    },
    changeSort:{  /* 是否重置排序 */
      type:Boolean,
      // default(){
      //   return true
      // }
    }
  },
  data () {
    return {

    }
  },
  watch: { 
    // 点击搜索清除 排序
    changeSort:{
      handler(){
          this.$refs.table.clearSort()
      }
    }
  },
  methods: {
    /**注意这里是解构***/
    /**利用单元格的 className 的回调方法，给行列索引赋值**/
    tableCellClassName({row, column, rowIndex, columnIndex}){
      row.index=rowIndex;
      column.index=columnIndex;
     },
     /**  点击单元格 **/
      cellClickFtn(row, column, cell, event){
        switch (this.clickFtn){
          case 0:
            return false;
          case 1:
          this.$router.push({name:'InvestmentRecommendDet',params:{id:row.ftzId}})
          break;
        }
      },

      /** 排序方法 **/
      sortChange(column, key, order) {
        switch (this.sortMethod){
          case 0:
            return false;
          case 1:
          let str = column.prop
              if (column.order === 'ascending') {
                  this.tableData.sort((a, b) => {
                      return a[str] - b[str]
                  })
              } else if (column.order === 'descending') {
                  this.tableData.sort((a, b) => {
                      return b[str] - a[str]
                  })
              }else {
                  this.tableData.sort((a, b) => {
                      return a[str] - b[str]
                  })
              }
          break;

         }
      },

      /**  合并单元格 **/
      objectSpanMethod({ row, column, rowIndex, columnIndex }){
        switch(this.spanMethod){
           case 0:
             return false
           case 1:  /** 合并 相同的 第一个数列 **/
            if(columnIndex === 0){
                  let obj = []
                  let contactDot = 0
                  this.tableData.forEach((item,index)=>{
                   if(index === 0){
                        obj.push(1)
                   }else{
                      if(item.oneIndex === this.tableData[index -1].oneIndex){
                        obj[contactDot] = obj[contactDot] + 1
                        obj.push(0)
                      }else{
                        contactDot = index
                        obj.push(1)
                      }
                   }
                   })

                   if(obj[rowIndex]){
                        const row = obj[rowIndex];
                        const col = row>0 ? 1 : 0;
                         return{
                         rowspan:row,
                         colspan:col,
                         }
                    }else{
                         return{
                           rowspan:0,
                           colspan:0,
                         }
                    }
            }
            break;
        }
      },

  },
  mounted () {
  }
}
</script>

<style scoped>
.myNote{
  display:-webkit-box;
  text-overflow:ellipsis;
  overflow:hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient:vertical;
}
</style>
